{
  "codexEntityForm": {
    "character": "Personagem",
    "place": "Lugar",
    "faction": "Facção",
    "object": "Objeto",
    "concept": "Conceito",
    "editName": "Editar {{name}}",
    "newCodexEntry": "Nova entrada do Códice",
    "theWorldHasChangedTheDraft": "O mundo mudou. O rascunho foi mantido; recarregue a entrada antes de salvar.",
    "portraitChooseAnImage": "Retrato: escolha uma imagem",
    "change": "Trocar",
    "addPortrait": "Adicionar retrato",
    "portraitImage": "Imagem do retrato",
    "entryName": "Nome da entrada",
    "name": "Nome",
    "entryType": "Tipo de entrada",
    "customCategory": "Categoria personalizada",
    "categoryEGDeityShipSpell": "Categoria, p. ex. Divindade, Navio, Feitiço",
    "aliases": "Apelidos",
    "entryAliases": "Apelidos da entrada",
    "otherNamesOneAtATime": "Outros nomes, um de cada vez…",
    "tags": "Etiquetas",
    "entryTags": "Etiquetas da entrada",
    "themesRolesArcs": "Temas, papéis, arcos…",
    "collection": "Coleção",
    "entryCollection": "Coleção da entrada",
    "noCustomCollection": "Nenhuma coleção personalizada",
    "folder": "Pasta",
    "entryFolder": "Pasta da entrada",
    "unfiled": "Sem pasta",
    "notes": "Notas",
    "entryNotes": "Notas da entrada",
    "whoTheyAreWhatTheyWant": "Quem é, o que quer, o que o leitor nunca deve descobrir cedo demais…",
    "entryFields": "Campos da entrada",
    "fields": "Campos",
    "fieldTemplate": "Modelo de campos",
    "template": "Modelo…",
    "schemaOf": "Esquema de",
    "addMissingFields": "Adicionar campos que faltam",
    "addField": "Adicionar campo",
    "noCustomFieldYetFieldsGive": "Nenhum campo personalizado ainda. Os campos dão a uma entrada fatos estruturados — idade, lealdade, um segredo — sobre os quais as Verificações podem raciocinar.",
    "sharedFieldNamesTypesAndOptions": "Nomes, tipos e opções de campos compartilhados são gerenciados nas configurações da coleção. Os valores pertencem a esta página.",
    "fieldNameN": "Nome do campo {{n}}",
    "fieldName": "Nome do campo",
    "fieldTypeN": "Tipo do campo {{n}}",
    "unknown": "Desconhecido",
    "fieldValueN": "Valor do campo {{n}}",
    "select": "Selecionar…",
    "yes": "Sim",
    "no": "Não",
    "value": "Valor",
    "chooseAnEntry": "Escolha uma entrada…",
    "eGSpringOfYear12": "p. ex. Primavera do ano 12, ou o dia do cerco",
    "below": "Abaixo",
    "unknownValueN": "Valor desconhecido {{n}}",
    "required": "Obrigatório",
    "sharedField": "Campo compartilhado",
    "remove": "Remover",
    "confirmRemoval": "Confirmar remoção",
    "paragraph": "Parágrafo",
    "aFewLines": "Algumas linhas…",
    "discardTheDraft": "Descartar o rascunho?",
    "confirmReload": "Confirmar recarga",
    "keepEditing": "Continuar editando",
    "reloadEntry": "Recarregar entrada",
    "cancel": "Cancelar",
    "chooseAnImageFileForThe": "Escolha um arquivo de imagem para o retrato.",
    "thePortraitMustBeUnder8": "O retrato deve ter menos de 8 MiB.",
    "saveEntry": "Salvar verbete",
    "searchEntries": "Pesquisar verbetes…"
  },
  "codexEntryDialog": {
    "newCodexEntry": "Nova entrada do Códice",
    "savedToWorldCodexTheManuscript": "Salva em Mundo › Códice; o manuscrito vai mencioná-la onde você estava digitando.",
    "createAndMention": "Criar e mencionar"
  },
  "continuityPanel": {
    "relationsOverTime": "Relações ao longo do tempo",
    "checkingRelations": "Verificando relações…",
    "cancel": "Cancelar",
    "theProjectHasChangedRunThe": "O manuscrito ou o mundo mudou desde esta execução. Rode as verificações de novo para atualizar as relações.",
    "anAnalysisLimitWasReachedThe": "Um limite da análise foi atingido. O resultado é parcial.",
    "ruleApplied": "Regra: “{{label}}”, {{rule}}.",
    "oneSourcePerTarget": "uma origem para cada destino",
    "oneTargetPerSource": "um destino para cada origem",
    "interval": "de {{start}} a {{end}}",
    "openScene": "Abrir {{scene}}",
    "findingReferenceMissing": "Aponta para uma entrada que não existe mais.",
    "findingConfirmedWithoutEvidence": "Confirmada sem uma citação do texto, então a fonte não pode ser verificada.",
    "findingEvidenceMissing": "Uma citação em que ela se apoia não existe mais.",
    "findingEvidenceNotCurrent": "Uma citação em que ela se apoia não está confirmada ou não corresponde mais ao texto.",
    "findingExclusiveNotEvaluable": "Não pode ser verificada pela regra: ela precisa de uma direção, das duas pontas e de um intervalo de tempo completo.",
    "findingExclusiveOverlap": "Duas delas valem ao mesmo tempo, o que a regra não permite.",
    "findingOther": "Algo a verificar nesta relação.",
    "theProjectExceedsTheLimitOf": "O projeto excede o limite desta análise. Nenhum dado foi alterado.",
    "theAnalysisExceededItsExecutionLimit": "A análise excedeu o limite de execução. Nenhum dado foi alterado.",
    "analysisCancelled": "Análise cancelada.",
    "checksNotCompletedTheTextAnd": "Verificações não concluídas. O texto e o cânone não foram alterados."
  },
  "eventTimelinePanel": {
    "eventHistory": "Histórico de eventos",
    "timeline": "Linha do tempo",
    "newEvent": "Novo evento",
    "searchEvents": "Pesquisar eventos",
    "searchEvents2": "Pesquisar eventos…",
    "timelineOrder": "Ordem da linha do tempo",
    "storyTime": "Tempo da história",
    "readingOrder": "Ordem de leitura",
    "dateStatus": "Situação da data",
    "allDates": "Todas as datas",
    "resolvedDates": "Datas resolvidas",
    "unresolvedDates": "Datas não resolvidas",
    "filterEventsByScene": "Filtrar eventos por cena",
    "allScenes": "Todas as cenas",
    "scenes": "Cenas",
    "editEvent": "Editar evento",
    "closeEventEditor": "Fechar editor de evento",
    "theWorldHasChangedReloadThe": "O mundo mudou. Recarregue o evento antes de salvar; os campos do rascunho foram mantidos.",
    "eventTitle": "Título do evento",
    "whatHappens": "O que acontece",
    "scene": "Cena",
    "eventScene": "Cena do evento",
    "notLinked": "Sem vínculo",
    "removedSceneSceneid": "Cena removida — {{sceneId}}",
    "dateType": "Tipo de data",
    "eventDateType": "Tipo de data do evento",
    "unknown": "Desconhecida",
    "definedInterval": "Intervalo definido",
    "relativeToAnEvent": "Relativa a um evento",
    "start": "Início",
    "eventStart": "Início do evento",
    "endExclusive": "Fim (exclusivo)",
    "eventEnd": "Fim do evento",
    "referenceEvent": "Evento de referência",
    "select": "Selecionar…",
    "referenceToVerifyAnchoreventid": "Referência a verificar — {{anchorEventId}}",
    "events": "Eventos",
    "offsetInTicks": "Deslocamento em ticks",
    "eventOffset": "Deslocamento do evento",
    "saveEvent": "Salvar evento",
    "closeReload": "Fechar / recarregar…",
    "discardTheDraftChanges": "Descartar as alterações do rascunho?",
    "discardDraft": "Descartar rascunho",
    "reloadEvent": "Recarregar evento",
    "keepEditing": "Continuar editando",
    "noEventMatchesTheseFiltersEvents": "Nenhum evento corresponde a estes filtros. Os eventos são aquilo sobre o que as Verificações raciocinam: quando algo aconteceu e em que cena o leitor fica sabendo.",
    "tickStart": "Tick {{start}}",
    "openScene": "Abrir cena",
    "editTitle": "Editar {{title}}",
    "removeTitle": "Remover {{title}}",
    "confirmEventRemoval": "Confirmar remoção do evento",
    "cancel": "Cancelar",
    "theWorldHasChangedCancelAnd": "O mundo mudou: cancele e reabra a confirmação.",
    "resolvedDate": "Data resolvida",
    "unknownDate": "Data desconhecida",
    "missingReference": "Referência ausente",
    "timeCycle": "Ciclo de tempo",
    "dateOutOfRange": "Data fora do intervalo",
    "eventsFoundOfTotal_one": "{{count}} evento encontrado · {{total}} no total",
    "eventsFoundOfTotal_many": "{{count}} eventos encontrados · {{total}} no total",
    "eventsFoundOfTotal_other": "{{count}} eventos encontrados · {{total}} no total",
    "removeThisEventReferences_one": "Remover este evento? {{count}} referência direta precisará de revisão.",
    "removeThisEventReferences_many": "Remover este evento? {{count}} referências diretas precisarão de revisão.",
    "removeThisEventReferences_other": "Remover este evento? {{count}} referências diretas precisarão de revisão.",
    "showMoreEvents_one": "Mostrar mais {{count}} evento",
    "showMoreEvents_many": "Mostrar mais {{count}} eventos",
    "showMoreEvents_other": "Mostrar mais {{count}} eventos"
  },
  "fieldEditor": {
    "choose": "Escolher…",
    "labelSearch": "Pesquisa de {{label}}",
    "search": "Pesquisar…",
    "labelOptions": "Opções de {{label}}",
    "noMatch": "Nenhum resultado.",
    "optionsOnePerLine": "Opções, uma por linha",
    "fieldOptionsIndex": "Opções do campo {{index}}",
    "addOptionIndex": "Adicionar opção {{index}}",
    "newOption": "Nova opção",
    "addOption": "Adicionar opção",
    "fieldValueIndex": "Valor do campo {{index}}",
    "chooseOptions": "Escolher opções…",
    "chooseEntries": "Escolher entradas…",
    "unsupportedMultiValueEditor": "Editor de valores múltiplos não compatível"
  },
  "graphExplorer": {
    "relationGraph": "Grafo de relações",
    "entry": "Entrada",
    "filterGraphByEntry": "Filtrar o grafo por entrada",
    "all": "Todas",
    "status": "Status",
    "graphRelationStatus": "Status das relações do grafo",
    "proposedAndConfirmed": "Propostas e confirmadas",
    "confirmed": "Confirmadas",
    "proposed": "Propostas",
    "relation": "Relação",
    "searchRelationInTheGraph": "Pesquisar relação no grafo",
    "filterAtStoryTime": "Filtrar no tempo da história",
    "tick": "Tick",
    "graphTick": "Tick do grafo",
    "includeUnknownTime": "Incluir tempo desconhecido",
    "enterANumericTickOrTurn": "Digite um tick numérico ou desative o filtro de tempo.",
    "navigableRelationGraph": "Grafo de relações navegável",
    "selectName": "Selecionar {{name}}",
    "entryCount_one": "{{count}} verbete",
    "entryCount_many": "{{count}} de verbetes",
    "entryCount_other": "{{count}} verbetes",
    "relationCount_one": "{{count}} relação",
    "relationCount_many": "{{count}} de relações",
    "relationCount_other": "{{count}} relações",
    "hiddenBeyondViewLimit": "{{entries}} e {{relations}} além do limite da visualização.",
    "relationsWithMissingEntries_one": "{{count}} relação com verbetes ausentes.",
    "relationsWithMissingEntries_many": "{{count}} relações com verbetes ausentes.",
    "relationsWithMissingEntries_other": "{{count}} relações com verbetes ausentes.",
    "unknownDurationIncluded_one": "{{count}} relação com duração desconhecida incluída no filtro.",
    "unknownDurationIncluded_many": "{{count}} relações com duração desconhecida incluídas no filtro.",
    "unknownDurationIncluded_other": "{{count}} relações com duração desconhecida incluídas no filtro.",
    "unknownDurationExcluded_one": "{{count}} relação com duração desconhecida excluída do filtro.",
    "unknownDurationExcluded_many": "{{count}} relações com duração desconhecida excluídas do filtro.",
    "unknownDurationExcluded_other": "{{count}} relações com duração desconhecida excluídas do filtro."
  },
  "relationshipPanel": {
    "select": "Selecionar…",
    "removedReference": "Referência removida:",
    "projectRelations": "Relações do projeto",
    "relationsOf": "Relações de",
    "filterRelationsByEntry": "Filtrar relações por entrada",
    "allEntries": "Todas as entradas",
    "searchEntries": "Pesquisar entradas…",
    "searchRelations": "Pesquisar relações",
    "relationOrEntry": "Relação ou entrada",
    "newRelation": "Nova relação",
    "editRelation": "Editar relação",
    "relationsLinkTwoEntries": "Relações ligam duas entradas",
    "addTwoEntriesInTheCodex": "Adicione pelo menos duas entradas no Códice e depois escreva as palavras que as ligam, como “é mentor de”.",
    "theWorldHasChangedTheFields": "O mundo mudou enquanto isto estava aberto. Seus campos foram mantidos; recarregue para salvar sobre os dados novos.",
    "reload": "Recarregar",
    "anEntry": "Uma entrada",
    "anotherEntry": "Outra entrada",
    "relationSource": "Origem da relação",
    "relationType": "Tipo de relação",
    "isTheMentorOf": "é mentor de",
    "relationTarget": "Destino da relação",
    "direction": "Direção",
    "relationDirection": "Direção da relação",
    "oneWay": "Mão única",
    "bothWays": "Mão dupla",
    "when": "Quando",
    "relationTime": "Tempo da relação",
    "notSet": "Não definido",
    "betweenTwoMoments": "Entre dois momentos",
    "fromAnEvent": "A partir de um evento",
    "from": "De",
    "to": "a",
    "relationStart": "Início da relação",
    "relationEnd": "Fim da relação",
    "momentsHint": "Momentos na linha do tempo do mundo; o fim não é incluído.",
    "event": "Evento",
    "relationEvent": "Evento da relação",
    "offset": "Deslocamento",
    "relationOffset": "Deslocamento da relação",
    "offsetHint": "Momentos depois do evento; negativo para antes.",
    "status": "Status",
    "relationStatus": "Status da relação",
    "proposed": "Proposta",
    "confirmed": "Confirmada",
    "rejected": "Rejeitada",
    "superseded": "Substituída",
    "confirmedRelationsCountAsCanonIn": "Relações confirmadas valem como cânone nas Verificações.",
    "notes": "Notas",
    "relationNotes": "Notas da relação",
    "howTheStoryShowsItAnd": "Como a história a mostra e o que fica ambíguo.",
    "quotes": "Citações",
    "linkQuotes": "Vincular citações do texto",
    "quotesLinked": "Citações: {{count}}",
    "searchQuotations": "Pesquisar citações",
    "excerptOrNote": "Trecho ou nota",
    "removedQuotation": "Citação removida:",
    "noQuotationYetAnnotateAPassage": "Nenhuma citação ainda. Anote um trecho no manuscrito para citá-lo aqui.",
    "upTo100QuotationsShownUse": "Até 100 citações mostradas. Use a pesquisa para reduzir a lista.",
    "saveRelation": "Salvar relação",
    "cancel": "Cancelar",
    "aDeletedEntry": "uma entrada excluída",
    "aDeletedEvent": "um evento excluído",
    "timeBetween": "De {{start}} a {{end}}",
    "timeAtEvent": "Em {{event}}",
    "timeAfterEvent": "{{event}} + {{offset}}",
    "timeBeforeEvent": "{{event}} − {{offset}}",
    "noRelationsYet": "Nenhuma relação ainda.",
    "noRelationMatches": "Nenhuma relação corresponde.",
    "edit": "Editar",
    "editCaption": "Editar {{caption}}",
    "remove": "Remover",
    "removeCaption": "Remover {{caption}}",
    "removeThisRelationTheChangeStays": "Remover esta relação? A alteração permanece no histórico.",
    "confirmRemoval": "Remover",
    "shownOfTotal": "100 de {{total}} relações mostradas. Reduza a pesquisa para ver as outras.",
    "theWorldHasChangedReloadThe": "O mundo mudou. Recarregue a relação antes de salvar.",
    "theRelationWasChangedOrRemoved": "A relação foi alterada ou removida. Recarregue os dados.",
    "explicitlyConfirmTheRelationBeforeSaving": "Escolha Confirmada de novo para tornar esta relação cânone.",
    "selectTwoEntriesThatExistIn": "Selecione duas entradas que existam no Códice.",
    "fillInTheTimeValuesOr": "Preencha os momentos ou escolha Não definido.",
    "enterAValidIntervalTheEnd": "O fim deve vir depois do início.",
    "selectAnExistingEventAsThe": "Escolha um evento que ainda exista.",
    "theSelectedQuotationIsNoLonger": "Uma citação escolhida não existe mais.",
    "checkTheRelationTextAndThe": "Confira as palavras da relação e as notas.",
    "theChangeWasNotSavedReload": "A alteração não foi salva. Recarregue os dados e tente de novo."
  },
  "useWorldReplication": {
    "signInToTheLinkedAccount": "Entre na conta vinculada e confira seu acesso ao projeto. Suas alterações locais foram mantidas.",
    "syncTheManuscriptWithThisServer": "Sincronize o manuscrito com este servidor antes de vincular o Mundo dele.",
    "theWorldChangedAfterTheComparison": "O Mundo mudou depois da comparação. Revise as cópias atuais de novo.",
    "aConfirmationOrRestoredRecordNeeds": "Uma confirmação ou registro restaurado precisa de revisão explícita antes de sincronizar.",
    "anAttachmentOrRemoteCopyFailed": "Um anexo ou cópia remota falhou na verificação. Seu Mundo local foi mantido.",
    "theseChangesExceedASyncLimit": "Estas alterações excedem um limite de sincronização ou precisam ser aplicadas juntas. Seu Mundo local e as alterações pendentes foram mantidos.",
    "syncPausedYourLocalChangesAre": "Sincronização pausada. Suas alterações locais foram mantidas.",
    "newMapNeedsPlan": "Novos mapas fazem parte do Ink e do Press. O mapa fica neste dispositivo e o Mundo espera: remova o novo mapa ou escolha um plano para sincronizar de novo.",
    "worldSyncCouldNotFinishCheck": "A sincronização do Mundo não pôde terminar. Verifique a conexão e tente de novo. Suas alterações locais foram mantidas."
  },
  "vaultFolders": {
    "folderName": "Pasta {{name}}",
    "editFolder": "Editar pasta",
    "newSubfolder": "Nova subpasta",
    "moveContentsBeforeRemoving": "Mova o conteúdo antes de remover",
    "removeFolder": "Remover pasta",
    "folderActionsName": "Ações da pasta {{name}}",
    "chooseThisFolderWhenEditingA": "Escolha esta pasta ao editar uma página.",
    "projectFolders": "Pastas do projeto",
    "folders": "Pastas",
    "newFolder": "Nova pasta",
    "groupPagesFromAnyCollection": "Agrupe páginas de qualquer coleção.",
    "foldersOrganizePagesWithoutChangingTheir": "As pastas organizam as páginas sem alterar a coleção nem o conteúdo delas.",
    "cancel": "Cancelar",
    "saveFolder": "Salvar pasta",
    "name": "Nome",
    "folderName2": "Nome da pasta",
    "inside": "Dentro de",
    "parentFolder": "Pasta superior",
    "projectRoot": "Raiz do projeto",
    "removeEmptyFolder": "Remover pasta vazia?",
    "removeNameFromTheProject": "Remover “{{name}}” do projeto?"
  },
  "vaultTable": {
    "unavailableEntry": "Entrada indisponível",
    "vaultTable": "Tabela do cofre",
    "pages": "Páginas",
    "searchVaultTable": "Pesquisar na tabela do cofre",
    "searchPages": "Pesquisar páginas…",
    "tableCollection": "Coleção da tabela",
    "allCollections": "Todas as coleções",
    "noCustomCollection": "Nenhuma coleção personalizada",
    "tableFolder": "Pasta da tabela",
    "allFolders": "Todas as pastas",
    "unfiled": "Sem pasta",
    "scrollableVaultTable": "Tabela do cofre com rolagem",
    "name": "Nome",
    "collection": "Coleção",
    "folder": "Pasta",
    "noPagesMatchTheseFilters": "Nenhuma página corresponde a estes filtros.",
    "none": "Nenhum",
    "yes": "Sim",
    "no": "Não",
    "pagesShown_one": "{{shown}} de {{count}} página",
    "pagesShown_many": "{{shown}} de {{count}} páginas",
    "pagesShown_other": "{{shown}} de {{count}} páginas"
  },
  "vaultTree": {
    "blue": "Azul",
    "emerald": "Esmeralda",
    "gold": "Dourado",
    "violet": "Violeta",
    "rose": "Rosa",
    "amber": "Âmbar",
    "teal": "Verde-azulado",
    "slate": "Ardósia",
    "crimson": "Carmesim",
    "bark": "Casca",
    "forest": "Floresta",
    "navy": "Marinho",
    "orchid": "Orquídea",
    "saffron": "Açafrão",
    "ink": "Tinta",
    "ember": "Brasa",
    "concept": "Conceito",
    "character": "Personagem",
    "place": "Lugar",
    "faction": "Facção",
    "object": "Objeto",
    "vault": "Cofre",
    "newCollection": "Nova coleção",
    "vaultView": "Visão do cofre",
    "pages": "Páginas",
    "table": "Tabela",
    "pagesMarkedUnassignedKeepTheirPrevious": "Páginas marcadas como sem atribuição mantêm os campos anteriores. Edite uma página para escolher a coleção dela.",
    "filterPages": "Filtrar páginas",
    "filterPages2": "Filtrar páginas…",
    "worldVault": "Cofre do Mundo",
    "removeCollectionName": "Remover coleção {{name}}",
    "collectionSettingsForName": "Configurações da coleção {{name}}",
    "iconAndColour": "Ícone e cor",
    "newPageInName": "Nova página em {{name}}",
    "noPageYetAddTheFirst": "Nenhuma página ainda — adicione a primeira com +.",
    "nothingHereYet": "Nada aqui ainda.",
    "removeEmptyCollection": "Remover coleção vazia?",
    "removeNameAndItsSchema": "Remover “{{name}}” e o esquema dela?",
    "removeCollection": "Remover coleção",
    "text": "Texto",
    "theSvgMustBeUnder16": "O SVG deve ter menos de 16 KiB.",
    "thisFileIsNotAUsable": "Este arquivo não é um SVG utilizável (scripts e referências externas são removidos; a raiz deve ser <svg>).",
    "collectionName": "Coleção: {{name}}",
    "sharedFieldsApplyToEveryPage": "Os campos compartilhados valem para todas as páginas desta coleção. Cada página também pode ter campos próprios.",
    "cancel": "Cancelar",
    "saving": "Salvando…",
    "saveCollection": "Salvar coleção",
    "createCollection": "Criar coleção",
    "identity": "Identidade",
    "nameAndIconAsTheTree": "Nome e ícone, como a árvore e as páginas vão mostrá-los.",
    "name": "Nome",
    "collectionName2": "Nome da coleção",
    "magic": "Magia",
    "aCollectionWithThisNameAlready": "Já existe uma coleção com este nome.",
    "icon": "Ícone",
    "iconSource": "Origem do ícone",
    "lucide181": "Lucide (181)",
    "yourSvg": "Seu SVG",
    "collectionIcon": "Ícone da coleção",
    "searchLucideIcons": "Pesquisar ícones Lucide",
    "searchIconsCastleSwordMoon": "Pesquisar ícones — castelo, espada, lua…",
    "loadingIcons": "Carregando ícones…",
    "lucideIcon": "Ícone Lucide",
    "noIconMatches": "Nenhum ícone corresponde.",
    "chooseAnSvgFile": "Escolher um arquivo SVG",
    "customSvgIcon": "Ícone SVG personalizado",
    "upTo16KibScriptsLinks": "Até 16 KiB. Scripts, links e referências externas são removidos; use currentColor no arquivo para a cor da coleção valer.",
    "colour": "Cor",
    "aPresetOneYouUsedRecently": "Uma predefinida, uma usada recentemente ou a sua, pela roda de cores.",
    "collectionColour": "Cor da coleção",
    "recent": "Recentes",
    "useHex": "Usar {{hex}}",
    "kindOfPage": "Tipo de página",
    "everyPageIsACodexEntry": "Toda página é uma entrada do Códice de um tipo; o tipo decide como as Verificações, as menções com @ e o grafo a tratam, e mantém a cor dela em todo lugar.",
    "collectionBaseKind": "Tipo base da coleção",
    "magicOrShipsConceptDeitiesOr": "Magia ou Navios → Conceito · Divindades ou Casas → Personagem ou Facção · uma coleção de cidades → Lugar.",
    "sharedFields": "Campos compartilhados",
    "thePropertiesOfTheCollectionValues": "As propriedades da coleção — os valores ficam em cada página, e uma página ainda pode acrescentar os seus.",
    "collectionTemplate": "Modelo da coleção",
    "template": "Modelo…",
    "addField": "Adicionar campo",
    "exampleMagicLevelNumberRarityChoice": "Exemplo: Magia → Nível (número) · Raridade (escolha: comum, rara, lendária) · Obtida (data da história) · Ensinada por (link para entrada).",
    "collectionFieldNameValue": "Nome do campo da coleção {{value}}",
    "fieldName": "Nome do campo",
    "collectionFieldTypeValue": "Tipo do campo da coleção {{value}}",
    "collectionFieldOptionsValue": "Opções do campo da coleção {{value}}",
    "optionsOnePerLine": "Opções, uma por linha",
    "required": "Obrigatório",
    "requiredCollectionFieldValue": "Campo da coleção obrigatório {{value}}",
    "removeCollectionFieldValue": "Remover campo da coleção {{value}}",
    "yesNo": "Sim / Não",
    "multipleChoice": "Múltipla escolha",
    "storyDate": "Data da história",
    "entryLink": "Link para entrada",
    "multipleEntryLinks": "Vários links para entradas",
    "fieldParagraph": "Parágrafo",
    "fieldNumber": "Número",
    "fieldChoice": "Escolha"
  },
  "worldCloudPanel": {
    "worldCloudVersions": "Versões do Mundo na nuvem",
    "includesCodexPagesCollectionsFoldersFacts": "Inclui páginas do Códice, coleções, pastas, fatos, relações e anexos. Publique ou baixe uma versão explicitamente. O manuscrito usa a sincronização de cenas.",
    "compareVersions": "Comparar versões",
    "recoverPreviousWorld": "Recuperar Mundo anterior…",
    "deviceRevision": "Revisão do dispositivo",
    "accountVersionRemoteversion": "Versão da conta {{remoteVersion}}",
    "firstAccountVersion": "Primeira versão da conta",
    "uploadDeviceVersion": "Enviar versão do dispositivo…",
    "useAccountVersion": "Usar versão da conta…",
    "confirmTransfer": "Confirmar transferência",
    "replaceWorldOnThisDeviceWith": "Substituir o Mundo deste dispositivo por esta versão? Uma cópia do Mundo e dos anexos atuais será mantida antes. O texto do manuscrito não muda.",
    "saveThisCopyToYourAccount": "Salvar esta cópia na sua conta? As versões anteriores da conta serão mantidas.",
    "restoreWorldFromBeforeTheLast": "Restaurar o Mundo de antes da última transferência? Edições posteriores impedem esta restauração.",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "transferring": "Transferindo…",
    "codexPages": "Páginas do Códice",
    "updateStoryideBeforePublishingChangesTo": "Atualize o Musael antes de publicar alterações neste Cofre.",
    "theAccountVersionChangedCompareAgain": "A versão da conta mudou. Compare de novo antes de aplicar.",
    "worldChangedOnThisDeviceCompare": "O Mundo mudou neste dispositivo. Compare de novo antes de aplicar.",
    "accountVersionStorageIsFullPrevious": "O armazenamento de versões da conta está cheio. As cópias anteriores foram mantidas.",
    "anAttachmentFailedItsIntegrityCheck": "Um anexo falhou na verificação de integridade. Nenhuma cópia local foi substituída.",
    "theAccountCopyFailedItsIntegrity": "A cópia da conta falhou na verificação de integridade.",
    "noRecoveryCopyIsAvailableFor": "Não há cópia de recuperação disponível para esta transferência.",
    "anIdentifierIsAlreadyUsedIn": "Um identificador já é usado em outro projeto.",
    "openOrSyncTheManuscriptWith": "Abra ou sincronize antes o manuscrito com a sua conta.",
    "yourAccountDoesNotHaveThe": "Sua conta não tem a permissão necessária.",
    "signInAgainThisSessionWas": "Entre de novo. Esta sessão foi revogada.",
    "transferCancelled": "Transferência cancelada.",
    "transferFailedCheckYourConnectionAnd": "A transferência falhou. Verifique sua conexão e compare de novo.",
    "couldNotReadTheRecoveryCopy": "Não foi possível ler a cópia de recuperação.",
    "mondoPrecedenteRipristinato": "Mundo anterior restaurado.",
    "accountVersionVersionSaved": "Versão {{version}} da conta salva.",
    "versionVersionAppliedToWorldOn": "Versão {{version}} aplicada ao Mundo neste dispositivo.",
    "cancellationRequested": "Cancelamento solicitado.",
    "labelFacts": "Fatos",
    "labelEvents": "Eventos",
    "labelKnowledge": "Conhecimento",
    "labelAnnotations": "Anotações",
    "labelRelationships": "Relações",
    "labelAttachments": "Anexos",
    "labelCollections": "Coleções",
    "labelFolders": "Pastas",
    "changedCount_one": "{{count}} alterado",
    "changedCount_many": "{{count}} alterados",
    "changedCount_other": "{{count}} alterados"
  },
  "worldMaps": {
    "character": "Personagem",
    "place": "Lugar",
    "object": "Objeto",
    "faction": "Facção",
    "concept": "Conceito",
    "pinOf": "Marcador: {{name}}",
    "pinMissing": "Marcador de uma entrada ausente",
    "missingEntry": "Entrada ausente",
    "zoom": "Zoom",
    "zoomIn": "Aumentar zoom",
    "zoomOut": "Diminuir zoom",
    "fitToView": "Ajustar à tela",
    "newMap": "Novo mapa",
    "newMapDescription": "Uma imagem de um lugar, para pôr marcadores nas pessoas, lugares e coisas que estão ali.",
    "cancel": "Cancelar",
    "saving": "Salvando…",
    "createMap": "Criar mapa",
    "mapOf": "Mapa de",
    "aNewPlace": "Um novo lugar",
    "placeName": "Nome do lugar",
    "placeNamePlaceholder": "A Costa de Sal",
    "picture": "Imagem",
    "choosePicture": "Escolha um PNG, JPEG, WebP ou GIF",
    "pictureHint": "Até 16 MB. Ela vira um dos anexos da entrada.",
    "maps": "Mapas",
    "mapsLead": "Fixe entradas nas imagens dos seus lugares. Um lugar marcado que tem mapa próprio o abre.",
    "noMapsYet": "Nenhum mapa ainda",
    "noMapsText": "Dê uma imagem a um lugar e depois marque as entradas que pertencem a ele.",
    "addTheFirstMap": "Adicionar o primeiro mapa",
    "onePin": "1 marcador",
    "pins": "{{count}} marcadores",
    "inPlace": "em {{place}}",
    "chooseAnEntryOrName": "Escolha uma entrada ou escreva um nome para o marcador.",
    "mapTrail": "Mapas acima deste",
    "doneAdding": "Concluir",
    "addPin": "Adicionar marcador",
    "labels": "Rótulos",
    "replacePicture": "Trocar imagem",
    "removeMap": "Remover mapa",
    "hintClick": "Clique no mapa onde o marcador vai.",
    "hintChoose": "Escolha o que o marcador indica, à direita.",
    "pictureMissing": "A imagem deste mapa ainda não está neste dispositivo.",
    "pinDetails": "Detalhes do marcador",
    "newPin": "Novo marcador",
    "entry": "Entrada",
    "chooseAnEntry": "Escolha uma entrada",
    "noEntryLabelOnly": "Sem entrada, só um rótulo",
    "labelOnTheMap": "Rótulo no mapa",
    "labelDefault": "O nome da entrada",
    "labelRequired": "Necessário sem uma entrada",
    "placePin": "Fixar marcador",
    "label": "Rótulo",
    "openEntry": "Abrir entrada",
    "openItsMap": "Abrir o mapa dela",
    "position": "{{x}}% na horizontal, {{y}}% na vertical",
    "removePin": "Remover marcador",
    "noPinsYet": "Nenhum marcador ainda. Use Adicionar marcador e depois clique no mapa.",
    "shownOn": "Mostrado em",
    "openEntryOf": "Abrir {{name}}",
    "removeMapTitle": "Remover o mapa de {{name}}?",
    "removeMapMessage": "Os marcadores vão junto. A imagem continua nos anexos da entrada."
  },
  "worldPanel": {
    "checks": "Verificações",
    "findAndFixConsistencyIssuesIn": "Os fatos, eventos e relações do seu mundo comparados com o manuscrito. Sem IA.",
    "running": "Executando…",
    "runChecks": "Executar verificações",
    "lastRunAt": "Última execução às {{time}}",
    "oneAtATime": "Um de cada vez",
    "exclusiveRelation": "Relação exclusiva",
    "noRelationIsExclusive": "Nenhuma relação é exclusiva",
    "exclusivityType": "Tipo de exclusividade",
    "oneSourcePerTarget": "Uma origem para cada destino",
    "oneTargetPerSource": "Um destino para cada origem",
    "oneAtATimeHint": "Uma relação que só pode valer para um de cada vez, como “possui”: dois donos da mesma coisa nos mesmos momentos viram um conflito.",
    "rulesNeedRelations": "As regras usam as suas relações. Adicione uma em Conexões, como “possui”, e torne-a exclusiva aqui.",
    "results": "Resultados",
    "whatTheChecksLookFor": "O que as verificações procuram",
    "twoHoldersAtOnce": "Dois portadores ao mesmo tempo",
    "eventsOutOfOrder": "Eventos fora de ordem",
    "quotedPastItsLimit": "Citado além do limite",
    "linksToDeletedEntries": "Vínculos com entradas excluídas",
    "notesThatLostTheirPlace": "Notas que perderam o lugar",
    "relationsOverTime": "Relações ao longo do tempo",
    "scopeOwnership": "Uma coisa mantida por duas entradas nos mesmos momentos, a partir de fatos confirmados.",
    "scopeFlashback": "Um evento lido depois de outro que acontece mais tarde no mundo: um flashback ou um deslize.",
    "scopeReveal": "Um fato citado numa cena depois da última que você permitiu para ele.",
    "scopeOrphans": "Notas e fatos que apontam para uma entrada ou um cartão da Biblioteca que não existe mais.",
    "scopeAnchors": "Um trecho citado cujas palavras se moveram ou mudaram na cena.",
    "scopeRelations": "Relações contra a regra acima e contra as citações em que se baseiam.",
    "filterResults": "Filtrar resultados",
    "all": "Todos",
    "conflicts": "Conflitos",
    "warnings": "Avisos",
    "needsData": "Faltam dados",
    "noIssuesFound": "Nenhum problema encontrado",
    "theExecutedRulesFoundNoViolation": "Nada contradiz os fatos e regras que você definiu. As verificações só conhecem o que você registrou.",
    "notEnoughData": "Dados insuficientes",
    "quotesInTheText": "Citações no texto",
    "anchorInPlace": "No lugar",
    "anchorMoved": "Movida",
    "anchorGone": "Sumiu",
    "reAnchor": "Reancorar",
    "openScene": "Abrir cena",
    "checkedAt": "Verificado às {{time}}.",
    "twoHold": "{{a}} e {{b}} possuem “{{object}}” ao mesmo tempo.",
    "heldTwice": "{{a}} possui “{{object}}” duas vezes nos mesmos momentos.",
    "flashbackSentence": "“{{earlier}}” acontece antes de “{{later}}” no mundo, mas é lido depois dele: um flashback — a menos que não fosse essa a sua intenção.",
    "revealSentence": "“{{fact}}” é citado em {{scene}}, depois da última cena que você permitiu para ele.",
    "allowedUpToScene": "Permitido até a cena {{scene}}",
    "orphanFactSentence": "Um fato (“{{fact}}”) é sobre uma entrada que foi excluída.",
    "orphanNoteSentence": "A nota sobre “{{excerpt}}” aponta para uma entrada excluída.",
    "orphanConceptSentence": "A nota sobre “{{excerpt}}” aponta para um cartão da Biblioteca que não existe mais.",
    "movedSentence": "“{{excerpt}}” mudou de lugar em {{scene}}: reancore a nota para acompanhá-lo.",
    "eventWithoutTime": "“{{title}}” não tem tempo no mundo, então a ordem dele não pode ser verificada.",
    "factWithoutTime": "“{{fact}}” não tem intervalo de tempo, então o dono não pode ser verificado.",
    "recordWithoutTime": "Um registro não tem tempo, então não pode ser verificado.",
    "aDeletedEntry": "uma entrada excluída",
    "aDeletedEvent": "um evento excluído",
    "aScene": "uma cena",
    "fromTo": "De {{start}} a {{end}}",
    "relativeToAnEvent": "Relativo a um evento",
    "timeNotSet": "Não definido",
    "facts": "Fatos",
    "factsLead": "O que você afirma sobre cada entrada. As verificações leem os que você confirma e os comparam com o manuscrito.",
    "entries": "Entradas",
    "addAnEntry": "Adicionar uma entrada",
    "addTheFirstEntry": "Adicionar a primeira entrada",
    "newEntityName": "Nome da nova entidade",
    "entityType": "Tipo de entidade",
    "addEntity": "Adicionar entidade",
    "character": "Personagem",
    "place": "Lugar",
    "object": "Objeto",
    "faction": "Facção",
    "other": "Outro",
    "deleteEntityReferencesBecomeOrphaned": "Excluir entidade (as referências ficam órfãs)",
    "deleteEntityName": "Excluir entidade {{name}}",
    "noFactYet": "Nenhum fato sobre {{name}} ainda. Um novo fato começa como proposto; confirme-o para que conte.",
    "proposed": "Proposto",
    "confirmed": "Confirmado",
    "rejected": "Rejeitado",
    "superseded": "Substituído",
    "worldFact": "Fato do mundo",
    "characterBelief": "Crença",
    "testimony": "Testemunho",
    "authorHypothesis": "Hipótese",
    "confirm": "Confirmar",
    "confirmExplicitApproval": "Confirmar (aprovação explícita)",
    "newFactAbout": "Novo fato sobre {{name}}",
    "predicatePlaceholder": "possui",
    "predicate": "Predicado",
    "valuePlaceholder": "a espada",
    "value": "Valor",
    "kind": "Tipo",
    "epistemicKind": "Tipo epistêmico",
    "kindHint": "Só os fatos do mundo valem como verdade; crenças, testemunhos e hipóteses são guardados, mas não verificados como cânone.",
    "when": "Quando",
    "timeKind": "Tipo de tempo",
    "betweenTwoMoments": "Entre dois momentos",
    "from": "De",
    "to": "a",
    "startTick": "Tick inicial",
    "endTick": "Tick final",
    "momentsHint": "Momentos na linha do tempo do mundo; o fim não é incluído.",
    "reveal": "Revelação",
    "maximumRevealNarrativeIndex": "Revelação máxima (índice narrativo)",
    "noLimit": "Sem limite",
    "sceneNumbered": "{{n}}. {{title}}",
    "revealHint": "Citações deste fato numa cena posterior são sinalizadas.",
    "addFactProposed": "Adicionar como proposto",
    "selectAnEntityToSeeAnd": "Escolha uma entrada para ver e adicionar os fatos dela.",
    "noEntityYet": "Nenhuma entrada ainda. Adicione um personagem, um lugar ou um objeto acima ou no Códice.",
    "resultDetails": "Detalhes do resultado",
    "conflict": "Conflito",
    "warning": "Aviso",
    "whatWasCompared": "O que foi comparado",
    "whatToDo": "O que fazer",
    "comparedOwnership": "Fatos do mundo confirmados, com intervalo de tempo. Dois portadores da mesma coisa não podem se sobrepor.",
    "comparedFlashback": "O tempo de cada evento no mundo contra a ordem da cena dele no livro.",
    "comparedReveal": "A última cena que você permitiu para um fato contra as cenas que o citam.",
    "comparedOrphans": "Cada nota e fato contra as entradas e cartões da Biblioteca que existem.",
    "comparedAnchors": "A citação de cada nota contra o texto atual da cena.",
    "confirmOnlyOneOwnerInThe": "Mantenha um só portador nesses momentos: estreite um dos intervalos de tempo ou volte um fato para proposto.",
    "ifTheSceneIsADeliberate": "Se a cena é um flashback deliberado, mantenha-a. Caso contrário, mova a cena ou mude o tempo do evento.",
    "raiseTheMaximumRevealSceneOf": "Permita uma cena posterior para o fato ou mova a citação para antes.",
    "restoreTheMissingEntityFromThe": "Restaure a entrada pelo histórico do Códice ou exclua a nota ou o fato que aponta para ela.",
    "useReAnchorManualOnThe": "Use Reancorar na citação nos resultados ou abra a cena e selecione o trecho de novo.",
    "giveTheEventOrFactAn": "Dê a ele um tempo no mundo ou deixe sem: a verificação fica em silêncio em vez de adivinhar.",
    "selectAResult": "Selecione um resultado",
    "detailsConstraintsAndSuggestedFixesAppear": "O que foi comparado e o que fazer aparecem aqui.",
    "thisAnnotationCannotBeReAnchored": "Esta nota não pode ser reancorada: “{{excerpt}}” está ausente ou aparece mais de uma vez na cena.",
    "revisionTools": "Ferramentas de revisão",
    "loadingRevisionTools": "Carregando ferramentas de revisão…"
  },
  "worldReplicationPanel": {
    "theContentChangedWhileItWas": "O conteúdo mudou durante a confirmação. Escolha o conteúdo e a aprovação que você revisou.",
    "theseChangesCannotBeCombinedInto": "Estas alterações não podem ser combinadas em um Mundo válido. Escolha a versão completa a manter; as duas cópias permanecem em recuperação.",
    "thisDevice": "Este dispositivo",
    "yourAccount": "Sua conta",
    "viewWorld": "Ver Mundo",
    "previousSharedValue": "Valor compartilhado anterior",
    "theActionCouldNotFinishYour": "Não foi possível concluir a ação. Suas alterações locais foram mantidas.",
    "worldSync": "Sincronização do Mundo",
    "syncCodexPagesFactsTimelinesCollections": "Sincronize páginas do Códice, fatos, linhas do tempo, coleções e anexos entre dispositivos. Notas e esboços são sincronizados à parte, abaixo.",
    "syncWorldAutomatically": "Sincronizar o Mundo automaticamente",
    "n1PendingChange": "1 alteração pendente",
    "pendingPendingChanges": "{{pending}} alterações pendentes",
    "syncNow": "Sincronizar agora",
    "exportRecoveryCopies": "Exportar cópias de recuperação",
    "compareBeforeSyncing": "Comparar antes de sincronizar",
    "signInToTheLinkedAccount": "Entre na conta vinculada para sincronizar. As alterações locais continuam salvas.",
    "signInToCompareYourWorld": "Entre para comparar o seu Mundo e ativar a sincronização.",
    "chooseYourStartingWorld": "Escolha o seu Mundo de partida",
    "bothCopiesHaveTheSameContent": "As duas cópias têm o mesmo conteúdo.",
    "keepTheWorldOnThisDevice": "Mantenha o Mundo deste dispositivo ou use a cópia da sua conta. O Mundo local e os anexos anteriores ficam guardados em recuperação.",
    "keepThisDeviceSync": "Manter este dispositivo e sincronizar",
    "useAccountCopySync": "Usar a cópia da conta e sincronizar",
    "cancel": "Cancelar",
    "reviewConcurrentChanges": "Revisar alterações simultâneas",
    "chooseEachValueToKeepOther": "Escolha cada valor a manter. As outras alterações são mescladas automaticamente. As duas versões continuam recuperáveis.",
    "applyReviewedChoices": "Aplicar escolhas revisadas",
    "syncingWorldAndAttachments": "Sincronizando Mundo e anexos…",
    "codexPages": "Páginas do Códice",
    "onThisDevice": "Neste dispositivo",
    "waitingToSync": "Aguardando sincronização",
    "syncing": "Sincronizando…",
    "upToDate": "Em dia",
    "reviewNeeded": "Revisão necessária",
    "emptyText": "(texto vazio)",
    "emptyList": "(lista vazia)",
    "worldStructure": "Estrutura do Mundo",
    "labelFacts": "Fatos",
    "labelEvents": "Eventos",
    "labelKnowledge": "Conhecimento",
    "labelAnnotations": "Anotações",
    "labelRelationships": "Relações",
    "labelAttachments": "Anexos",
    "labelCollections": "Coleções",
    "labelFolders": "Pastas",
    "paused": "Pausada",
    "addedCount_one": "{{count}} adicionado",
    "addedCount_many": "{{count}} adicionados",
    "addedCount_other": "{{count}} adicionados",
    "removedCount_one": "{{count}} removido",
    "removedCount_many": "{{count}} removidos",
    "removedCount_other": "{{count}} removidos",
    "changedCount_one": "{{count}} alterado",
    "changedCount_many": "{{count}} alterados",
    "changedCount_other": "{{count}} alterados",
    "removedValue": "Removido",
    "emptyValue": "Vazio"
  },
  "worldReviewTools": {
    "deletedEntry": "Entrada excluída",
    "timeUnknown": "Tempo desconhecido",
    "storyTimeInterval": "Intervalo no tempo da história",
    "relativeToEventPreserved": "Relativo a um evento (preservado)",
    "from": "De",
    "until": "Até",
    "characterKnowledge": "Conhecimento do personagem",
    "couldNotCheckTheSavedManuscriptRetry": "Não foi possível verificar o manuscrito salvo. Tente de novo.",
    "revisionTools": "Ferramentas de revisão",
    "changeImpact": "Impacto da alteração",
    "whatPointsToThisRecord": "O que aponta para este registro?",
    "explicitLinksOnlyIncludingIndirectLinksChangingARecord": "Só vínculos explícitos, incluindo os indiretos. Alterar um registro não reescreve os que dependem dele.",
    "impactRecord": "Registro de impacto",
    "chooseARecord": "Escolha um registro",
    "linkedRecordsWorldRevision": "registros vinculados · revisão do Mundo",
    "directLink": "Vínculo direto",
    "missingSourceScene": "Cena de origem ausente",
    "noExplicitRecordLinksToThisEntryUnlinkedProse": "Nenhum registro vinculado explicitamente a esta entrada. A prosa sem vínculo está fora desta verificação.",
    "whenDidTheyLearnIt": "Quando ficaram sabendo?",
    "recordAcquisitionAndUseOnTheSameStoryTime": "Registre a aquisição e o uso no mesmo eixo de tempo da história. Palpites e crenças ficam separados; a ordem dos capítulos nunca é tratada como tempo da história.",
    "recordKnowledge": "Registrar conhecimento",
    "couldNotSaveCheckTheIntervalsOrCancelAnd": "Não foi possível salvar. Confira os intervalos ou cancele e reabra se o Mundo mudou.",
    "character": "Personagem",
    "knowledgeCharacter": "Personagem do conhecimento",
    "chooseACharacter": "Escolha um personagem",
    "fact": "Fato",
    "knowledgeFact": "Fato do conhecimento",
    "chooseAConfirmedWorldFact": "Escolha um fato do mundo confirmado",
    "acquired": "Adquirido",
    "acquisitionSource": "Fonte da aquisição",
    "noSourceAttached": "Nenhuma fonte anexada",
    "use": "Uso",
    "scene": "Cena",
    "chooseAScene": "Escolha uma cena",
    "knownInformation": "Informação conhecida",
    "belief": "Crença",
    "guess": "Palpite",
    "passageSource": "Fonte do trecho",
    "noPassageAttached": "Nenhum trecho anexado",
    "removeUse": "Remover uso",
    "addUse": "Adicionar uso",
    "confirmAndSave": "Confirmar e salvar",
    "cancel": "Cancelar",
    "missingFact": "Fato ausente",
    "atUnknownRelativeTime": "em tempo desconhecido/relativo",
    "edit": "Editar",
    "couldNotRemoveTheRecordRefreshAndRetry": "Não foi possível remover o registro. Atualize e tente de novo.",
    "checkSavedKnowledge": "Verificar conhecimento salvo",
    "theWorldChangedSinceThisResultRunTheCheck": "O Mundo mudou desde este resultado. Rode a verificação de novo.",
    "recordedUseIsEarlierThanAcquisition": "O uso registrado é anterior à aquisição",
    "recordedTimesAreInOrder": "Os tempos registrados estão em ordem",
    "beliefOrGuessNotAKnowledgeConflict": "Crença ou palpite — não é um conflito de conhecimento",
    "notEnoughInformationToCompare": "Informação insuficiente para comparar",
    "attachedPassagesMatchTheSavedText": "Os trechos anexados coincidem com o texto salvo",
    "aSourceIsMissingStaleOrBelongsToAnother": "Uma fonte está ausente, desatualizada ou pertence a outra cena",
    "authorRecordedTimesPassagesAreNotVerified": "Tempos registrados por você; os trechos não são verificados",
    "openScene": "Abrir cena",
    "noConfirmedKnowledgeUsesToCompare": "Não há usos de conhecimento confirmados para comparar.",
    "openNamedScene": "Abrir {{title}}",
    "recordSummary": "Usos: {{count}} · {{lifecycle}} · Adquirido {{time}}",
    "checkSummary": "Verificado às {{time}} · {{count}} usos registrados. Atualize depois de editar a prosa.",
    "resultsLimitedTo500Records": "Resultados limitados a 500 registros",
    "linksAway": "a {{depth}} vínculos de distância",
    "useNKind": "Usar {{n}} tipo",
    "useN": "Usar {{n}}",
    "useNSource": "Usar {{n}} fonte",
    "checking": "Verificando…"
  },
  "worldSection": {
    "overview": "Visão geral",
    "vault": "Cofre",
    "timeline": "Linha do tempo",
    "connections": "Conexões",
    "references": "Referências",
    "checks": "Verificações",
    "analysis": "Análise",
    "characters": "Personagens",
    "locations": "Locais",
    "factions": "Facções",
    "objects": "Objetos",
    "concepts": "Conceitos",
    "worldViews": "Visões do Mundo",
    "world": "Mundo",
    "browseByType": "Explorar por tipo",
    "filterByType": "Filtrar por tipo",
    "all": "Todos",
    "newEntry": "Nova entrada",
    "cercaNelCodex": "Pesquisar no Códice",
    "searchEntries": "Pesquisar entradas…",
    "entry": "entrada",
    "entries": "entradas",
    "alsoAliases": "Também: {{aliases}}",
    "noEntriesYetCreateTheFirst": "Nenhuma entrada ainda. Crie o primeiro personagem, lugar ou facção.",
    "noEntryMatches": "Nenhuma entrada corresponde.",
    "editName": "Editar {{name}}",
    "edit": "Editar",
    "archive": "Arquivar",
    "confirmArchive": "Confirmar arquivamento",
    "notesAndSketches": "Notas e esboços",
    "alsoKnownAs": "Também conhecido como",
    "addADescriptionOneLineThat": "Acrescente uma descrição — uma linha que diga o que é isto.",
    "none": "Nenhum",
    "yes": "Sim",
    "no": "Não",
    "removedEntry": "Entrada removida",
    "unavailableEntry": "Entrada indisponível",
    "noNotesYetEditTheEntry": "Ainda sem notas. Edite a entrada para descrevê-la.",
    "linkedScenes": "Cenas vinculadas",
    "showTheEntriesOfABook": "Mostrar as entradas de um livro",
    "allBooks": "Todos os livros",
    "bookLine": "Livro {{number}} · {{title}}",
    "inNoBookYet": "Em nenhum livro ainda",
    "scenesThatMentionThisEntryBy": "As cenas que mencionam esta entrada por nome ou apelido aparecem aqui.",
    "facts": "Fatos",
    "noFactRecordedFactsAreAdded": "Nenhum fato registrado. Os fatos são adicionados e aprovados em Verificações.",
    "relations": "Relações",
    "noRelationYet": "Nenhuma relação ainda.",
    "proposed": " · proposta",
    "viewAll": "Ver todas",
    "attachments": "Anexos",
    "attachAnImageToUseIt": "Anexe uma imagem para usá-la como retrato.",
    "kib": "KiB",
    "open": "Abrir",
    "remove": "Remover",
    "addAttachment": "Adicionar anexo",
    "stateAtStoryTime": "Estado no tempo da história",
    "tick": "Tick",
    "factsWithoutACompleteInterval": "fatos sem um intervalo completo.",
    "selectAnEntry": "Selecione uma entrada",
    "charactersPlacesFactionsAndObjectsLive": "Personagens, lugares, facções e objetos vivem aqui, com seus fatos, relações e anexos.",
    "recentChanges": "Alterações recentes",
    "undoChange": "Desfazer alteração",
    "worldTimeline": "Linha do tempo do Mundo",
    "eventsPeopleAndPlacesInA": "Eventos, pessoas e lugares num contexto maior.",
    "noEventYet": "Nenhum evento ainda",
    "addTheFirstEventWithA": "Adicione o primeiro evento com um tempo de história ou deixe o tempo desconhecido até saber.",
    "tick2": "tick",
    "plotEvent": "Evento do enredo",
    "worldEvent": "Evento do mundo",
    "openScene": "Abrir cena",
    "unknownTime": "Tempo desconhecido",
    "unknown": "desconhecido",
    "seeHowYourWorldSPeople": "Veja como as pessoas, os lugares e as ideias do seu mundo se conectam.",
    "connectionsView": "Visão de conexões",
    "graph": "Grafo",
    "list": "Lista",
    "nothingToConnectYet": "Nada a conectar ainda",
    "createEntriesInTheCodexAnd": "Crie entradas no Códice e relacione-as na visão em Lista.",
    "selectedEntry": "Entrada selecionada",
    "relationSummary": "Resumo das relações",
    "noSceneMentionsThisEntryYet": "Nenhuma cena menciona esta entrada ainda.",
    "openInCodex": "Abrir no Códice",
    "selectANodeToSeeIts": "Selecione um nó para ver as relações e cenas dele.",
    "annotationsAnchoredInTheManuscriptAnd": "Anotações ancoradas no manuscrito e os arquivos que você guarda para o seu mundo.",
    "addFile": "Adicionar arquivo",
    "annotations": "Anotações",
    "selectTextInTheManuscriptAnd": "Selecione um texto no manuscrito e use “Anotar” para ancorar um recurso, uma entidade ou uma nota.",
    "scene": "Cena",
    "device": "Recurso",
    "entity": "Entidade",
    "note": "Nota",
    "imagesPdfsNotesAndAudioYou": "Imagens, PDFs, notas e áudio que você anexa ao mundo ou a uma entrada.",
    "linked": "Vinculado",
    "orphan": "Órfão",
    "openFile": "Abrir arquivo",
    "referenceDetails": "Detalhes da referência",
    "textAnnotation": "Anotação de texto",
    "kind": "Tipo",
    "anchor": "Âncora",
    "concept": "Conceito",
    "created": "Criado",
    "anchorStatesValidStaleOrphanedAnd": "Os estados da âncora (válida, desatualizada, órfã) e a reancoragem são calculados em Verificações.",
    "attachment": "Anexo",
    "type": "Tipo",
    "size": "Tamanho",
    "linkedTo": "Vinculado a",
    "added": "Adicionado",
    "confirmRemove": "Confirmar remoção",
    "selectAnAnnotationOrAFile": "Selecione uma anotação ou um arquivo.",
    "exploreTheShapeOfYourStory": "Explore a forma da sua história: tamanho, presença e densidade ao longo das cenas.",
    "sceneLength": "Tamanho das cenas",
    "wordsPerScene": "Palavras por cena",
    "noScenesYet": "Nenhuma cena ainda.",
    "titleFmtWords": "{{title}}: {{fmt}} palavras",
    "entityDensity": "Densidade de entidades",
    "codexMentionsPerScene": "Menções ao Códice por cena",
    "titleMentionsMentions": "{{title}}: {{mentions}} menções",
    "characterAppearanceMap": "Mapa de aparições dos personagens",
    "aDotWhereACharacterIs": "Um ponto onde um personagem é nomeado numa cena",
    "addCharactersToTheCodexAnd": "Adicione personagens ao Códice e nomeie-os nas cenas.",
    "thisScene": "Esta cena",
    "words": "Palavras",
    "paragraphs": "Parágrafos",
    "sentencesEst": "Frases (est.)",
    "distinctWords": "Palavras distintas",
    "annotatedDevices": "Recursos anotados",
    "n1000Words": "/ 1.000 palavras",
    "repetitions": "Repetições",
    "exportHtml": "Exportar HTML",
    "exportTxt": "Exportar TXT",
    "events": "Eventos",
    "confirmedFacts": "Fatos confirmados",
    "recentlyChanged": "Alterados recentemente",
    "changesToTheWorldWillBe": "As alterações no mundo serão listadas aqui, cada uma com um desfazer.",
    "undo": "Desfazer",
    "startHere": "Comece aqui",
    "overviewEmptyLead": "As pessoas, os lugares e os eventos da sua história, ligados às cenas em que aparecem.",
    "addACharacter": "Adicionar um personagem",
    "addACharacterText": "Quem é, o que quer e o que está no caminho.",
    "addAPlace": "Adicionar um lugar",
    "addAPlaceText": "Onde as cenas acontecem: uma cidade, um navio, um único cômodo.",
    "addAnEventText": "Algo que acontece na história, com data ou sem ela.",
    "inThisWorld": "Neste mundo",
    "createAnEntry": "Criar uma entrada",
    "aCharacterAPlaceAFaction": "Um personagem, um lugar, uma facção, um objeto ou um conceito.",
    "addAnEvent": "Adicionar um evento",
    "withAnExactStoryTimeOr": "Com um tempo de história exato ou desconhecido.",
    "runTheChecks": "Rodar as verificações",
    "deterministicRulesOwnershipOrderAnchorsOrphans": "Donos, ordem, revelações e relações ao longo do tempo, comparados com o texto.",
    "loadingTheWorld": "Carregando o mundo…",
    "maps": "Mapas",
    "openItsMap": "Abrir o mapa dela",
    "addAMap": "Adicionar um mapa",
    "pinnedOn": "Fixado em",
    "typeCharacter": "Personagem",
    "typeLocation": "Local",
    "typeObject": "Objeto",
    "typeFaction": "Facção",
    "typeConcept": "Conceito",
    "annotationsToReAnchor_one": "{{count}} anotação a reancorar.",
    "annotationsToReAnchor_many": "{{count}} de anotações a reancorar.",
    "annotationsToReAnchor_other": "{{count}} anotações a reancorar."
  }
}
